import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ReliableFlowForYourHome from "./sections/ReliableFlowForYourHome";
import PourquoiBoxify from "./sections/PourquoiBoxify";
import OperativeExzellenzInIzmir from "./sections/OperativeExzellenzInIzmir";
import ReadyToInnovate from "./sections/ReadyToInnovate";
import FooterInfo from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ReliableFlowForYourHome />
      <PourquoiBoxify />
      <OperativeExzellenzInIzmir />
      <ReadyToInnovate />
      <FooterInfo />
    </div>;
}